module.exports = __webpack_public_path__ + "static/media/6.e72b34d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/6.svg
// module id = 411
// module chunks = 14